export const REQUEST_FETCH_PERMALINK_AD = "REQUEST_FETCH_PERMALINK_AD";
export const FETCH_PERMALINK_AD_SUCCESS = "FETCH_PERMALINK_AD_SUCCESS";
export const FETCH_PERMALINK_AD_FAILURE = "FETCH_PERMALINK_AD_FAILURE";

export const CLEAR_FETCH_PERMALINK_AD_STATES =
  "CLEAR_FETCH_PERMALINK_AD_STATES";
